import {toUpper} from 'lodash';
import React from 'react';
import Icon from '../../../components/icon';
import {Column, Row} from '../../../components/layout';
import colors from '../../../util/colors';
import {Icons} from '../../../util/icons';
import {strings} from '../../../util/strings';
import {createGUID} from '../../../util/utility';
import {PreAuthorizationItem} from '../PreAuthorizations';
import PreAuthorizationtListItem from './PreAuthorizationtListItem';

type PreAuthorizationListProps = {
  authorizationItems: PreAuthorizationItem[] | undefined;
  labels: typeof strings.pt.preAuthorizations;
  statuses: any[];
  clickable?: boolean;
  selectedItem(filterItem: PreAuthorizationItem): void;
};

function PreAuthorizationList(props: PreAuthorizationListProps) {
  return (
    /*if collection is empty, show message 'there are none'*/
    props.authorizationItems?.length === 0 ||
      !props.authorizationItems?.length ? (
      <Column className="reimbursement-history-no-reimbursementsyet">
        <Icon
          className="reimbursement-history-filter-icon"
          name={Icons.ALERT_PROBLEM}
          color={colors.lightGrey}
          width="40"
          height="40"
          changeViewbox
          viewBox={'0 0 24 24'}
        />
        <h6 style={{color: colors.lightGrey, marginTop: 20}}>
          {props.labels?.preAuthorizations_noRequest}
        </h6>
      </Column>
    ) : (
      <>
        <Row className="list-header-row">
          <Column className="reimbursement-history-header">
            {toUpper(props.labels?.medicalActIn)}
          </Column>
        </Row>
        <div className="reimbursement-history-declarationlist-line"></div>
        {props.authorizationItems?.map((element: PreAuthorizationItem) => (
          <div
            key={createGUID()}
            onClick={() => props.clickable && props.selectedItem(element)}
            style={{cursor: props.clickable ? 'pointer' : 'default'}}>
            <PreAuthorizationtListItem
              key={createGUID()}
              preAuthorizationItem={element}
              statuses={props.statuses}
              selectedItem={() => null}></PreAuthorizationtListItem>
          </div>
        ))}
      </>
    )
  );
}

export default PreAuthorizationList;
